import { Injectable } from '@angular/core'
import { Http, Headers, RequestOptions, Response } from '@angular/http'
import { Observable, BehaviorSubject } from 'rxjs'
import 'rxjs/add/operator/map'
import * as _ from 'lodash'
import { Tree } from 'ng2-tree'

import { WebNotification } from '../pages/shared/components/notification/models/notification'
import { HttpService } from './http.service'
import { Constants } from '../app.constant';

@Injectable()
export class NotificationService extends HttpService {

  private unreadMessages: number = 0;
  public unreadMessagesCount: BehaviorSubject<number> = new BehaviorSubject(this.unreadMessages);
  private notiList: Array<WebNotification> = [];
  public notificationList: BehaviorSubject<WebNotification[]> = new BehaviorSubject(this.notiList);
  private _pagination: { [str: string]: any } = { nextPage: 1 };
  private notificationGettingInProgress: boolean = false;
  public recordPerPage=Constants.Var.REPORT_PAGINATION;

  getNotifications(page?: any): Observable<any> {
    let mockName = page && page.pageNumber != 1 ? 'notifications-web2' : 'notifications-web' // temp code
    let pageQuery={};
    if(page != null){
      pageQuery['pageNumber']=page.pageNumber;
      pageQuery['numPerPage']=this.recordPerPage;
    }
    let requestOptionsArgs = page ? { search: pageQuery } : {}
    return this.getApi('/push/web/notifications', requestOptionsArgs, mockName)
      .map(res => {
        let resJSON = res.json();
        if (resJSON && !_.isEmpty(resJSON.pagination)) {
          // isSamePage
          _.assignIn(this._pagination, resJSON.pagination)
        }
        else {
          throw new Error("INVALID_RESPONSE")
        }
        if (_.get(resJSON, 'result.notifications.length') > 0 &&
          this._pagination.currentPage == resJSON.pagination.currentPage
        ) {
          if (page.pageNumber == 1) {
            this.notiList = resJSON.result.notifications;
          } else {
            this.notiList = _.concat(this.notiList, resJSON.result.notifications);
          }
          this.notificationList.next(this.notiList);
        }
        if (page.pageNumber == 1 && !resJSON.result.notifications.length) {
          this.notiList = [];
          this.notificationList.next(this.notiList);
        }
        if (resJSON && resJSON.result && resJSON.result.unreadCount != null) {
          this.updateUnreadMessageCount(resJSON.result.unreadCount, true)
        }
        return resJSON
      })
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  getNotificationKeys(): Observable<any> {
    let requestOptionsArgs = {}
    return this.getApi('/push/web/keys', requestOptionsArgs, 'notification-keys')
      .map(res => res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)));
  }

  updateUnreadMessageCount(_no: number, shouldReplace: boolean = false) {
    if (/^[-+]?[0-9]+$/.test(_no + '')) {    // only access for positive and negative integer
      _no = (typeof _no == "number") ? _no : parseInt(_no, 10)
      this.unreadMessages = (shouldReplace) ? _no : this.unreadMessages + _no
      if (this.unreadMessages < 0) this.unreadMessages = 0      // if total unread goes less than 0, then set to 0
      this.unreadMessagesCount.next(this.unreadMessages)
    }
  }

  getNotificationsForNextPage(page?: number) {
    if(page){
      this._pagination.nextPage=page;
    }
    if (this._pagination.nextPage != null && this.notificationGettingInProgress != true) {
      this.notificationGettingInProgress = true;
     // this._pagination.nextPage++;
      this.getNotifications({ pageNumber: (page) ? page : this._pagination.nextPage })
        .finally(() => { this.notificationGettingInProgress = false;  })
        .subscribe(res => { }, err => { })
    }
  }

  resetList() {
    this.notiList = []
    this.unreadMessages = 0
    this._pagination = { nextPage: 1 }

    this.notificationGettingInProgress = true
    this.getNotifications()
      .finally(() => { this.notificationGettingInProgress = false; })
      .subscribe(res => { }, err => { })
  }

  markAsRead(_msgId: number): Observable<any> {
    let requestOptionsArgs = { body: { messageId: _msgId } }
    return this.putApi('/push/web/read', requestOptionsArgs, 'notification-mark-as-read')
      .map(res => res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)))
  }

  markAsReadAll(): Observable<any> {
    let requestOptionsArgs = { body: { markAllAsRead: true } }
    return this.putApi('/push/web/read', requestOptionsArgs, 'notification-mark-as-read')
      .map(res => res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)))
  }

  webTokenRegistration(_regId: string): Observable<any> {
    let requestOptionsArgs = { body: { registrationId: _regId } }
    return this.putApi('/push/web', requestOptionsArgs, 'notification-web-token-registration')
      .map(res => res.json())
      .catch((e) => Observable.throw(this.errorHandler(e)))
  }

  updateValue(_noti, i) {
    if (this.notiList[i] != null && _noti != null) {
      this.notiList[i] = _.assignIn(this.notiList[i], _noti)
    }
  }

  prependValue(_noti: WebNotification) {
    if (_noti == null) return;

    if (this.notiList.length == 0) {
      this.getNotifications()
        .finally(() => { this.notificationGettingInProgress = false; })
        .subscribe(res => { }, err => { })
    }
    else if (this.notiList.length > 0) {
      this.notiList.unshift(_noti)
      this.notificationList.next(this.notiList)
      this.updateUnreadMessageCount(+1)
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/services/notification.service.ts